export const introTooltipsKeys = {
    tooltipProfile: 'HELP_TOOLTIP_PROFILE',
    tooltipShop:    'HELP_TOOLTIP_SHOP',
};
